'use strict';
var parent = require('../../stable/instance/filter');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/instance/filter.js
// module id = 531
// module chunks = 13